<div class="alert alert-secondary mb-0" role="alert">
	<div class="alert-icon"><i class="flaticon-warning kt-font-brand"></i></div>
	<div class="alert-text" [ngClass]="{'message-info-format-text': textFormatted }" [innerHTML]="text"></div>
</div>
